import { SingleTeaser, TripleTeaser } from '@bnnvara/teasers';
import PropTypes from 'prop-types';
import React from 'react';
import { withTheme } from 'styled-components';

import {
  convertSingleTeaserItem,
  convertTripleTeaserItems,
} from '../../helpers/convertTeaser';

const BaseTeaser = ({ ...props }) => {
  const backgroundColor = ({ theme }) => theme.tertiary.main;

  const { items, LinkComponent, video } = props;

  if (!Array.isArray(items)) {
    return null;
  }

  if (items.length === 1) {
    return (
      <SingleTeaser
        {...convertSingleTeaserItem(items[0])}
        video={video}
        LinkComponent={LinkComponent}
        backgroundColor={backgroundColor}
      />
    );
  }

  if (items.length >= 2) {
    return (
      <TripleTeaser
        items={convertTripleTeaserItems(items)}
        LinkComponent={LinkComponent}
        backgroundColor={backgroundColor}
      />
    );
  }

  return null;
};

BaseTeaser.defaultProps = {
  LinkComponent: (props) => React.createElement('a', props),
  video: null,
};

BaseTeaser.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  video: PropTypes.node,
  LinkComponent: PropTypes.func,
};

export default withTheme(BaseTeaser);
